import useSplitedTableByColumn from '../../../hooks/useSplitedTableByColumn';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const _tables = [
  {
    name: 'Percentage breakdown of the total financing amount (221A) among the longest period for which the creditor is contractually committed to provide such financing',
    order: 222,
    columnLables: {
      financing_0_to_1_day: {
        name: '1 day or less',
        letter: 'A'
      },
      financing_2_to_7_days: {
        name: '2 - 7 days',
        letter: 'B'
      },
      financing_8_to_30_days: {
        name: '8 - 30 days',
        letter: 'C'
      },
      financing_31_to_90_days: {
        name: '31 - 90 days',
        letter: 'D'
      },
      financing_91_to_180_days: {
        name: '91 - 180 days',
        letter: 'E'
      },
      financing_181_to_365_days: {
        name: '181 - 365 days',
        letter: 'F'
      },
      financing_over_365_days: {
        name: 'more than 365 days',
        letter: 'G'
      }
    }
  }
];

export function FinancingLiquidity2({
  onChangeFund,
  funds,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useSplitedTableByColumn({
    data: funds[currentDataKey]?.fund_data?.FINANCING_PROFILE,
    onChangeFund,
    schema: schema.FINANCING_PROFILE,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.FINANCING_PROFILE?.field_names || [],
    isMultiFunds,
    funds,
    tableName: 'FINANCING_PROFILE',
    tables: _tables,
    isSingleData: true
  });

  return (
    <StyledTables id="fca-reporttables-financing-liquidity-2-group">
      {tables.map((rows, index) => (
        <Table
          id={`fca-reporttables-financing-liquidity-2-table-${index + 1}`}
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
          key={index + 'FINANCING_PROFILE-2'}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
        />
      ))}
    </StyledTables>
  );
}
